const PaymentOperator = {
    STRIPE: "stripe",
    MERCADO_PAGO_PIX: "mercadopagopix",
    MERCADO_PAGO: "mercadopago",
    PAGAR_ME: "pagarme",
    PAGAR_ME_PIX: "pagarmepix",
};

PaymentOperator.contains = (str) => {
    return Object.values(PaymentOperator).includes(str);
};

Object.freeze(PaymentOperator);

module.exports = PaymentOperator;